import React from 'react'
import { MountSmartviewOnClick as Original } from '@morningtrain/react-smartviews'
import InjectProps from 'support/utilities/InjectProps'
import classNames from 'classnames'

export default function MountSmartviewOnClick (props) {
  return (
    <Original {...props}>
      <InjectProps injectedProps={(child) => ({
        className: classNames(child.props.className, 'cursor-pointer'),
      })}>
        {props.children}
      </InjectProps>
    </Original>
  )
}
